import React from "react";
import { Box, Typography } from "@mui/material";
import { AccountTreeOutlined, BusinessOutlined } from "@mui/icons-material";
import {
  type FacilityHierarchyInput,
  getFacilityDropdownNameLine,
  getFacilityDropdownSubtitleLine,
} from "@utils/facilityUtils";

/** Matches facility type header box so the row stays visually aligned. */
export const FACILITY_HEADER_FIELD_MIN_HEIGHT_PX = 56;

export function FacilityPickerOptionContent({
  facility,
  isParent,
}: {
  facility: FacilityHierarchyInput;
  isParent: boolean;
}) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        width: "100%",
        minWidth: 0,
        boxSizing: "border-box",
      }}
    >
      {isParent ? (
        <AccountTreeOutlined
          sx={{
            fontSize: 18,
            color: "#0a829d",
            flexShrink: 0,
          }}
        />
      ) : (
        <BusinessOutlined
          sx={{
            fontSize: 18,
            color: "#465a63",
            flexShrink: 0,
          }}
        />
      )}
      <Box
        sx={{
          minWidth: 0,
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Typography
          component="span"
          sx={{
            fontSize: "14px",
            fontWeight: 500,
            color: "#262626",
            lineHeight: 1.35,
            wordBreak: "break-word",
          }}
        >
          {getFacilityDropdownNameLine(facility)}
        </Typography>
        <Typography
          component="span"
          sx={{
            fontSize: "12px",
            fontWeight: 400,
            color: "#5D6B72",
            lineHeight: 1.35,
            wordBreak: "break-word",
          }}
        >
          {getFacilityDropdownSubtitleLine(facility)}
        </Typography>
      </Box>
    </Box>
  );
}
